"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MistBase = (function () {
    function MistBase(config, files) {
        var _this = this;
        this.start = function (onStart) {
            _this.onStart = onStart;
            return _this;
        };
        this.progress = function (onProgress) {
            _this.onProgress = onProgress;
            return _this;
        };
        this.success = function (onSuccess) {
            _this.onSuccess = onSuccess;
            return _this;
        };
        this.error = function (onError) {
            _this.onError = onError;
            return _this;
        };
        this.files = files;
        this.config = config;
        this.onStart = function () { return null; };
        this.onProgress = function () { return null; };
        this.onSuccess = function () { return null; };
        this.onError = function () { return null; };
    }
    return MistBase;
}());
exports.default = MistBase;
